import { Route, Redirect } from "react-router-dom";
import Navbar from "../components/Home/NavbarIndex"
import Footer from "../components/Home/FooterIndex";

const AppRoute = ({
  component: Component,
  isAuthProtected,
  pageId,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Navbar />
          <Component {...props} />
          <Footer />
        </>
      )}
    />
  );
};

export default AppRoute;
